export const appConfig = {
    // API_CORE: 'http://localhost:3095/dev',
    //API_CORE: 'https://7nvkkdk83c.execute-api.us-east-1.amazonaws.com/dev',
    // API_CORE: 'https://wn6g90c3ik.execute-api.us-east-1.amazonaws.com/qa',
    API_CORE: 'https://api-centia-pm.simply.com.gt',
    TIMEOUT: 20000
}
